import {ValueObject} from '@s-ui/domain'

export class NewsCommentsCollectionValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Array<CommentEntity>} data.comments
   */
}
